<div class="checkbox" (click)="toggle()" [class.selected]="selected">
    <i class="pi pi-check"></i>
</div>